// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_uBk","cls2":"FocusedNav-cls2_fuh FocusedNav-cls1_uBk"};